import React, { createContext, useState, useEffect, useRef } from 'react';

export const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [openParentPack, setOpenParentPack] = useState(null);
  const [isChildPopupOpen, setIsChildPopupOpen] = useState(false); // Tracks if a child popup is open
  const popupRef = useRef(null); // Ref for the parent popup

  const openPackParent = (packName) => {
    console.log('🟢 openPackParent called with:', packName);
    if (openParentPack === packName) {
      console.log('🔴 Closing the pack:', packName);
      setOpenParentPack(null);
    } else {
      console.log('🟢 Opening the pack:', packName);
      setOpenParentPack(packName);
    }
  };

  // Manage child popup state
  const openChildPopup = () => {
    console.log("🟢 Un pack enfant vient d'être ouvert.");
    setIsChildPopupOpen(true);
  };

  const closeChildPopup = () => {
    console.log("🔴 Un pack enfant vient d'être fermé.");
    setIsChildPopupOpen(false);
  };

  // Handle clicks outside the parent popup
  useEffect(() => {
    const handleClickOutside = (event) => {
      console.log('📌 Click detected:', event.target);
      console.log('🔎 Valeur actuelle de isChildPopupOpen:', isChildPopupOpen);

      if (isChildPopupOpen) {
        console.log('🟡 Pack enfant ouvert, ne pas fermer le pack parent.');
        return;
      }

      if (event.target.closest('.logo-item-dashboardClient')) {
        console.log('✅ Click on logo detected, do nothing.');
        return;
      }

      if (openParentPack && popupRef.current && !popupRef.current.contains(event.target)) {
        console.log('🔴 Click outside detected, closing parent popup.');
        setOpenParentPack(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [openParentPack, isChildPopupOpen]);

  // Close all popups (parent and child)
  const closeAllPopups = () => {
    console.log("🔴 Fermeture de tous les popups après le paiement.");
    setOpenParentPack(null);
    setIsChildPopupOpen(false);
  };

  return (
    <PopupContext.Provider
      value={{
        openParentPack,
        openPackParent,
        popupRef,
        isChildPopupOpen,
        openChildPopup,
        closeChildPopup,
        closeAllPopups,
      }}
    >
      {children}
    </PopupContext.Provider>
  );
};